import { render, staticRenderFns } from "./PortfolioHistoryChart.vue?vue&type=template&id=ed95e696&scoped=true&"
import script from "./PortfolioHistoryChart.vue?vue&type=script&lang=js&"
export * from "./PortfolioHistoryChart.vue?vue&type=script&lang=js&"
import style0 from "./PortfolioHistoryChart.vue?vue&type=style&index=0&id=ed95e696&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed95e696",
  null
  
)

export default component.exports